import { axiosInstance } from '../axiosInstance'

export const getBaseApplicationUserData = () => {
  return axiosInstance.get('/unsecured/v1/utils/currentuser/')
}
